<template>
  <b-input-group>
    <multiselect
      v-model="value"
      :options="this.getOptions()"
      :close-on-select="true"
      label="label"
      track-by="value"
      :allow-empty="false"
      placeholder="Pick a value">
      <template slot="singleLabel" slot-scope="{ option }">
        <strong>{{ option.label }}</strong>
      </template>
    </multiselect>
  </b-input-group>
</template>

<script>
import Multiselect from 'vue-multiselect';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import I18N from "@/mixins/I18N";

export default {
  name: 'SelectBox',
  data() {
    return {
      varsValue: this.vars[0].value,
    };
  },
  computed: {
    value: {
      get() {
        return this.getOption(this.getSingleVar.value);
      },
      set(item) {
        this.varsValue = item.value;
        this.handleControl(this.varsValue);
      },
    },
  },
  methods: {
    getOptions() {
      if (this.getSingleVar.validation === null || typeof this.getSingleVar.validation !== 'object') {
        return [];
      }
      let { validation } = this;
      if (validation[this.selectedLanguage] !== undefined) {
        validation = this.validation[this.selectedLanguage];
      }
      if (Array.isArray(validation)) {
        return validation.map(item => ({
          value: Number.parseInt(item[0], 10),
          label: item[1],
        }));
      }
      return Object.keys(validation).map(key => ({
        value: Number.parseInt(key, 10),
        label: validation[key],
      }));
    },
    getOption(value) {
      return this.getOptions().filter(option => option.value === value)[0];
    },
  },
  mixins: [
    BaseControlMixin,
    I18N,
  ],
  components: {
    Multiselect,
  },
};
</script>

<style scoped>

</style>
